/* RESPONSIBLE TEAM: team-proactive-support */
import EditTourRoute from '../outbound/tour/edit';
export default EditTourRoute;
